import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import s from './FlexItem.scss';
class FlexItem extends React.Component {
    render() {
        const props = this.props;
        const classNames = classnames(s['root'], props.order && s[`order-${props.order}`], props.grow && s['grow'], props.shrink && s['shrink'], props.justifySelf && s[`justify-self-${props.justifySelf}`], props.alignSelf && s[`align-self-${props.alignSelf}`], props.className);
        return /*#__PURE__*/ React.createElement("div", {
            className: classNames,
            style: props.style ? _object_spread({}, props.style) : undefined,
            ref: props.innerRef,
            "aria-label": props['aria-label']
        }, this.props.children);
    }
}
export default FlexItem;
